import React, {useEffect, useRef, useState} from "react";
import {
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  TextField,
} from "@material-ui/core";
import { useStore } from "@store/store";
import { toast } from "react-toastify";
import API from "@services/axios";
import { useDebouncedEffect } from "@hooks/debounceEffect";
import validationSchema from "@utils/validationSchemas";
import { schema } from "@utils/schemas";

import {
  FETCH_GEOFENCE,
  FETCH_GEOFENCE_SUCCESS,
  FETCH_GEOFENCE_FAILURE,
  ADD_GEOFENCE,
  ADD_GEOFENCE_SUCCESS,
  ADD_GEOFENCE_FAILURE,
  DELETE_GEOFENCE,
  DELETE_GEOFENCE_SUCCESS,
  DELETE_GEOFENCE_FAILURE,
  FETCH_GEOFENCE_LIST,
  FETCH_GEOFENCE_LIST_SUCCESS,
  FETCH_GEOFENCE_LIST_FAILURE,
  FETCH_GEOFENCE_GROUP_LIST,
  FETCH_GEOFENCE_GROUP_LIST_SUCCESS,
  FETCH_GEOFENCE_GROUP_LIST_FAILURE
} from "@utils/actionTypes";

import closeIcon from "@assets/images/close.svg";
import { TableListingPopupStyle } from "./style";
import TableListing from "../table-listing";
import AddGeofence from "./../add-geofence";
import SearchIcon from "@assets/images/search.svg";
import { useFormik } from "formik";
import { rowsPerPageVal } from "@utils/constant";
import DeletePopup from "@components/deletePopup";
import {useParams} from "react-router-dom";
import uncheckedIcon from "@assets/images/uncheck-icon.svg";
import checkedIconOrange from "@assets/images/cheked-icon-orange.svg";
import { EDIT_CUSTOMER_ADDRESS } from "@utils/actionTypes";


function TableListGeoFencePopup(props) {
  const classes = TableListingPopupStyle();
  const [state, dispatch] = useStore();
  const [scroll] = useState("body");
  const [openAddGeofencePopup, setOpenAddGeofencePopup] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");
  const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageVal);
  const [openDeletePopup, setOpenDeletePopup] = useState(false);
  const [debounceSearch, setDebounceSearch] = useState("");
  const [deleteGeofence, setDeleteGeofence] = useState({});
  const [geofenceId, setGeofenceId] = useState("");
  const [addGeofence, setAddGeofence] = useState(schema.addGeofenceSchema);
  const [err, setError] = useState("");
  const [tooltipCustomer, setTooltipCustomer] = useState(false);
  const [onClickHiddenTooltip, setOnClickHiddenTooltip] = useState(false);
  const isFirstRender = useRef(true);

  const { id } = useParams();

  /** Add Geofence dialog **/
  const getGeofenceGroupList = () => {
    dispatch({ type: FETCH_GEOFENCE_GROUP_LIST });
    API.get(`master/verizonGroups`)
      .then((response) => {
        dispatch({
          type: FETCH_GEOFENCE_GROUP_LIST_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((err) => {
        dispatch({ type: FETCH_GEOFENCE_GROUP_LIST_FAILURE, payload: err });
      });
  }

  const handleAddGeofencePopup = () => {
    setOpenAddGeofencePopup(true);
    const params = {
      customerAddressId: props.customerAddressId,
      name: "",
      groupId: "",
      category: "",
      geofenceId: []
    }
    getGeofenceGroupList();
    getFilteredGeofenceList(params);
  }
  const handleCloseAddGeofencePopup = () => {
    setOpenAddGeofencePopup(false);
    setAddGeofence(schema.addGeofenceSchema);
    setError("");
    formik.handleReset();
  }
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: addGeofence,
    validationSchema: validationSchema.addGeofenceValidationSchema,
    onSubmit: (value) => {
      //API Call Add Geofence
      dispatch({ type: ADD_GEOFENCE });
      API.post(`customers/addresses/${props.customerAddressId}/geofence`, {
        placeIds: value.geofenceId
      })
        .then((response) => {
          handleCloseAddGeofencePopup();
          toast.success("Geofences linked successfully");
          dispatch({
            type: ADD_GEOFENCE_SUCCESS,
            payload: response.data,
          });
          getGeofences();
          props.getAddress();
        })
        .catch((err) => {
          dispatch({ type: ADD_GEOFENCE_FAILURE, payload: err });
        });
    },
  });

  const getFilteredGeofenceList = (item) => {
    const params = {
      name: item.name,
      groupId: item.groupId,
      category: item.category
    };

    //Call Api to filter the Geofence List
    dispatch({ type: FETCH_GEOFENCE_LIST });
    API.get(`customers/addresses/${props.customerAddressId}/geofenceFilter`, {params})
      .then((response) => {
        dispatch({
          type: FETCH_GEOFENCE_LIST_SUCCESS,
          payload: response.data.data,
        });
        formik.setValues({
          name: formik.values.name,
          groupId: formik.values.groupId,
          category: formik.values.category,
          geofenceId: []
        });
      })
      .catch((err) => {
        dispatch({ type: FETCH_GEOFENCE_LIST_FAILURE, payload: err });
      });
  }

  /** List Geofence **/
  const handleSearch = (event) => {
    setSearch(event.target.value.trimStart());
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleDeletePopup = (item, geofenceId) => {
    setDeleteGeofence(item);
    setGeofenceId(geofenceId);
    setOpenDeletePopup(true);
    setError("");
  };
  const handleSorting = (event, property) => {
    const isAsc = orderBy === property.sortTitle && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property.sortTitle);
  };

  // API calling to get list of Geofences
  let getGeofences = () => {
    const params = {
      page: page + 1,
      size: rowsPerPage,
      ...(!!debounceSearch ? { search: debounceSearch } : {}),
      ...(!!order ? { order } : {}),
      ...(!!orderBy ? { orderBy } : {}),
    };
    dispatch({ type: FETCH_GEOFENCE });
    API.get(`customers/${id}/addresses/${props.customerAddressId}/geofences`, { params })
      .then((response) => {
        dispatch({
          type: FETCH_GEOFENCE_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((err) => {
        dispatch({ type: FETCH_GEOFENCE_FAILURE, payload: err });
      });
  };

  // API calling to delete Geofence
  const handleDelete = () => {
    dispatch({ type: DELETE_GEOFENCE });
    API.delete(`customers/addresses/${props.customerAddressId}/geofence/${geofenceId}`)
      .then((response) => {
        setOpenDeletePopup(false);
        getGeofences();
        props.getAddress();
        toast.success("Geofence Deleted Successfully");
        dispatch({
          type: DELETE_GEOFENCE_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        setError("You can't delete this record");
        dispatch({ type: DELETE_GEOFENCE_FAILURE, payload: error });
      });
  };

  // Debounce the search after 1 second
  useDebouncedEffect(
    () => {
      setDebounceSearch(search);
    },
    1000,
    [search],
  );

  useEffect(() => {
    if (props.customerAddressId) {
      getGeofences();
    }
  }, [page, rowsPerPage, order, orderBy, props.customerAddressId]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setPage(0);
    if (page === 0) {
      getGeofences();
    }
  }, [debounceSearch]);

  // Debounce the filter after 1 second
  useDebouncedEffect(
    () => {
      const params = {
        customerAddressId: props.customerAddressId,
        name: formik.values.name,
        groupId: formik.values.groupId,
        category: formik.values.category,
        geofenceId: []
      };
      formik.setTouched({
        ...formik.touched,
        geofenceId: false,
      });

      getFilteredGeofenceList(params);
    },
    1000,
    [formik.values.name, formik.values.groupId, formik.values.category],
  );

  useEffect(() => {
    if (props.hiddenTooltip !== undefined) {
      setTooltipCustomer(props.hiddenTooltip);
    }
  }, [props.hiddenTooltip]);

  const updateHiddenTooltipCustomer = (value) => {
    API.put(`customers/${id}/addresses/${props.customerAddressId}`, value)
      .then((response) => {
        // dispatch({
        //   type: EDIT_CUSTOMER_ADDRESS,
        //   payload: response.data.data,
        // });
      })
      .catch((error) => {
        console.log(`error: ${error}`);
        setError(error.response?.data?.message);
      });
  };

  const handleChangeCheckBox = async (e) => {
    const prevCheck = tooltipCustomer;
    const newCheck = e.target.checked;
    setOnClickHiddenTooltip(true);

    setTooltipCustomer(newCheck);

    const data = {
      ...props.dataCustomerById,
      hiddenTooltip: newCheck
    };

    try {
      await updateHiddenTooltipCustomer(data);
    } catch (err) {
      setTooltipCustomer(prevCheck); // revert on failure
    }
  };

  return (
    <>
      <Dialog
        open={props.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.customModal}
        scroll={scroll}
      >
        <div className="close-modal">
          <img src={closeIcon} alt="Close" onClick={props.handleClose} />
        </div>
        <DialogTitle id="alert-dialog-title">GEOFENCES</DialogTitle>
        <DialogContent>
          <div className={classes.tabHeadingRow}>
            <div className={classes.modalWrapper}>
              <div className={classes.searchWrapper}>
                <div className="form-gourp">
                  <TextField
                    placeholder="Search by Name/Group"
                    variant="outlined"
                    type="search"
                    InputProps={{
                      endAdornment: <img src={SearchIcon} alt="Search"/>,
                    }}
                    onChange={handleSearch}
                    value={search}
                  />
                </div>
              </div>
              <AddGeofence
                handleClickOpen={() => handleAddGeofencePopup()}
                handleClose={handleCloseAddGeofencePopup}
                open={openAddGeofencePopup}
                formik={formik}
                error={err}
              />
            </div>
            <div className="form-gourp">
              <FormControlLabel
                className={[classes.forceMarginLeft, 'custom-checkbox'].join(' ')}
                control={
                  <Checkbox
                    icon={<img src={uncheckedIcon} alt="UnCheckBox" />}
                    checkedIcon={
                      <img src={checkedIconOrange} alt="CheckBox" />
                    }
                    onChange={(e) => handleChangeCheckBox(e)}
                    checked={onClickHiddenTooltip ? tooltipCustomer : props.hiddenTooltip}
                    name="check"
                  />
                }
                label="Hide tooltip"/>
            </div>
          </div>
          <TableListing
            page={page}
            handleOpen={(place, geofenceId) => handleDeletePopup(place, geofenceId)}
            rowsPerPage={rowsPerPage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleChangePage={handleChangePage}
            handleSorting={(e, property) =>
              handleSorting(e, property)
            }
            orderBy={orderBy}
            order={order}
          />
          <DeletePopup
            open={openDeletePopup}
            handleClose={() => setOpenDeletePopup(false)}
            handleDelete={() => handleDelete()}
            deleteUser={deleteGeofence.name}
            loading={state.geofence.loadingDeleteGeofence}
            error={err}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}

export default TableListGeoFencePopup;
